module.exports = __webpack_public_path__ + "ccb6638598cdd8d10d26e4dbc0b93e80.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/logo3.png
 ** module id = 211
 ** module chunks = 1
 **/